import SegmentedButton from "@/components/SegmentedButton";
import { InteractionInput } from "@/components/interactions/types";
import { useState } from "react";
import { Person, Facility, Event } from "./CreateGlobalInteractionSideSheet";
import { MultiPersonAdderManual } from "./MultiPersonAdderManual";
import { MultiPersonAdderFacility } from "./MultiPersonAdderFacility";
import { MultiPersonAdderEvent } from "./MultiPersonAdderEvent";

type argumentsType = {
  eventPeopleLoading: boolean;
  eventRegistrantsLoading: boolean;
  facilityPeopleLoading: boolean;
  gatheredEvents: Event[];
  gatheredFacilities: Facility[];
  ineligiblePerson: Person | undefined;
  ineligibleFacility: Facility | undefined;
  ineligibleEvent: Event | undefined;
  loading: boolean;
  peopleArray: Person[];
  setIneligiblePerson: (value: Person | undefined) => void;
  setIneligibleEvent: (value: Event | undefined) => void;
  setIneligibleFacility: (value: Facility | undefined) => void;
  setPeoplePGAId: (value: string) => void;
  setCurrentEvent: (value: Event | undefined) => void;
  setSearchedForPerson: (value: boolean) => void;
  setVariables: (value: InteractionInput) => void;
  setCurrentFacility: (value: Facility | undefined) => void;
  variables: InteractionInput;
};

export const MultiPersonAdder = ({
  eventPeopleLoading,
  eventRegistrantsLoading,
  facilityPeopleLoading,
  gatheredEvents,
  gatheredFacilities,
  ineligiblePerson,
  ineligibleEvent,
  ineligibleFacility,
  loading,
  peopleArray,
  setIneligiblePerson,
  setIneligibleEvent,
  setIneligibleFacility,
  setPeoplePGAId,
  setCurrentEvent,
  setSearchedForPerson,
  setVariables,
  setCurrentFacility,
  variables
}: argumentsType) => {
  const multiPersonAdderOptions = [
    { label: "Manual", value: "manual" },
    { label: "Facility", value: "facility" },
    { label: "Event", value: "event" }
  ];
  const [peopleGroup, setPeopleGroup] = useState(multiPersonAdderOptions[0].value);

  return (
    <div className="space-y-6">
      <SegmentedButton
        options={multiPersonAdderOptions}
        value={peopleGroup}
        onChange={(selection) => {
          selection && setPeopleGroup(selection);
        }}
        selectedColor="bg-sys-brand-secondary-container"
        textColor="text-sys-brand-on-secondary-container"
        backgroundColor="bg-sys-brand-surface-container-high"
        showCheckmark={true}
        fullWidth={true}
      />
      {peopleGroup === "manual" && (
        <>
          {loading ? (
            <div className="py-3 text-center text-sys-brand-on-surface-variant">Loading...</div>
          ) : (
            <MultiPersonAdderManual
              peopleArray={peopleArray}
              setSearchedForPerson={setSearchedForPerson}
              variables={variables}
              setVariables={setVariables}
              setPeoplePGAId={setPeoplePGAId}
              setIneligiblePerson={setIneligiblePerson}
              ineligiblePerson={ineligiblePerson}
              gatheredFacilities={gatheredFacilities}
              gatheredEvents={gatheredEvents}
            />
          )}
        </>
      )}
      {peopleGroup === "facility" && (
        <MultiPersonAdderFacility
          peopleArray={peopleArray}
          setSearchedForFacility={setSearchedForPerson}
          variables={variables}
          setVariables={setVariables}
          setIneligibleFacility={setIneligibleFacility}
          ineligibleFacility={ineligibleFacility}
          setCurrentFacility={setCurrentFacility}
          gatheredFacilities={gatheredFacilities}
          loading={facilityPeopleLoading}
        />
      )}
      {peopleGroup === "event" && (
        <MultiPersonAdderEvent
          peopleArray={peopleArray}
          setSearchedForEvent={setSearchedForPerson}
          variables={variables}
          setVariables={setVariables}
          setCurrentEvent={setCurrentEvent}
          setIneligibleEvent={setIneligibleEvent}
          ineligibleEvent={ineligibleEvent}
          gatheredEvents={gatheredEvents}
          loading={eventRegistrantsLoading || eventPeopleLoading}
        />
      )}
    </div>
  );
};
